module.exports = __webpack_public_path__ + "img/trendyol-logo.b2d68ca5.png";